import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-32 relative ${className}`} data-id="element-245">
      <motion.div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} data-id="element-246">
        {children}
      </motion.div>
    </section>;
}